import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconAlertTriangle } from '@tabler/icons-react';

/**
 * Used to insert a device faults placeholder into the editor.
 */
export default function InsertDeviceFaultsPlaceholder({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconAlertTriangle />}
      label="Nedostatky zariadenia"
      onClick={() => {
        editor?.chain().focus().insertDeviceFaultsPlaceholder().run();
        window.dispatchEvent(new CustomEvent('open-device-faults-configurator'));
      }}
    />
  );
}
